// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-frame-IFt22h{color:var(--coz-fg-primary);background:var(--coz-mg-hglt,rgba(186,192,255,.2));border-radius:8px;margin-bottom:24px;padding:12px 16px;font-size:12px;font-style:normal;font-weight:400;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message-frame": `message-frame-IFt22h`,
	"messageFrame": `message-frame-IFt22h`
};
export default ___CSS_LOADER_EXPORT___;
